'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _get_days_in_month = require('date-fns/get_days_in_month');

var _get_days_in_month2 = _interopRequireDefault(_get_days_in_month);

var _grid = require('../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _row = require('../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _dropDown = require('../../molecules/lists/dropDown');

var _dropDown2 = _interopRequireDefault(_dropDown);

var _Months_1_enCA = [{
	code: '1',
	value: 'January'
}, {
	code: '2',
	value: 'February'
}, {
	code: '3',
	value: 'March'
}, {
	code: '4',
	value: 'April'
}, {
	code: '5',
	value: 'May'
}, {
	code: '6',
	value: 'June'
}, {
	code: '7',
	value: 'July'
}, {
	code: '8',
	value: 'August'
}, {
	code: '9',
	value: 'September'
}, {
	code: '10',
	value: 'October'
}, {
	code: '11',
	value: 'November'
}, {
	code: '12',
	value: 'December'
}];

var _Months_1_enCA2 = _interopRequireDefault(_Months_1_enCA);

var _Months_1_frCA = [{
	code: '1',
	value: 'janvier'
}, {
	code: '2',
	value: 'f\xE9vrier'
}, {
	code: '3',
	value: 'mars'
}, {
	code: '4',
	value: 'avril'
}, {
	code: '5',
	value: 'mai'
}, {
	code: '6',
	value: 'juin'
}, {
	code: '7',
	value: 'julliet'
}, {
	code: '8',
	value: 'ao\xFBt'
}, {
	code: '9',
	value: 'septembre'
}, {
	code: '10',
	value: 'octobre'
}, {
	code: '11',
	value: 'novembre'
}, {
	code: '12',
	value: 'd\xE9cembre'
}];

var _Months_1_frCA2 = _interopRequireDefault(_Months_1_frCA);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DatePicker = function (_React$Component) {
	_inherits(DatePicker, _React$Component);

	function DatePicker() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, DatePicker);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			days: [],
			months: [],
			years: [],
			hours: [],
			minutes: [],
			seconds: [],
			day: null,
			month: null,
			year: null,
			hour: null,
			minute: null,
			second: null
		}, _this.setValue = function () {
			var year = null;
			var month = null;
			var day = null;
			var hour = null;
			var minute = null;
			var second = null;

			if (_this.props.value) {
				var value = new Date(_this.props.value);

				if (_this.props.isUTC) {
					year = '' + value.getUTCFullYear();
					month = '' + (value.getUTCMonth() + 1);
					day = '' + value.getUTCDate();
					if (_this.props.time) {
						hour = '' + value.getUTCHours();
						minute = '' + value.getUTCMinutes();
						second = '' + value.getUTCSeconds();
					}
				} else {
					year = '' + value.getFullYear();
					month = '' + (value.getMonth() + 1);
					day = '' + value.getDate();
					if (_this.props.time) {
						hour = '' + value.getHours();
						minute = '' + value.getMinutes();
						second = '' + value.getSeconds();
					}
				}
			}

			_this.setState({ year: year, month: month, day: day, hour: hour, minute: minute, second: second }, function () {
				_this.handleDate(year, month, day, hour, minute, second);
			});
		}, _this.handleDate = function (year, month, day, hour, minute, second) {
			_this.setState({ year: year, month: month, day: day, hour: hour, minute: minute, second: second });

			if (year && month) {
				var daysInMonth = (0, _get_days_in_month2.default)(new Date(year, month - 1));

				_this.setState({ days: _this.getOptions(1, daysInMonth, 0) });

				if (!day || day > daysInMonth) {
					_this.setState({ day: null });
				} else {
					var value = void 0;
					if (_this.props.isUTC) {
						value = new Date(Date.UTC(year, month - 1, day, hour || 0, minute || 0, second || 0));
					} else {
						value = new Date(year, month - 1, day, hour || 0, minute || 0, second || 0);
					}

					var valid = _this.props.mode === 'future' && value >= new Date() || _this.props.mode !== 'future';
					if (valid) {
						_this.props.changeEvent(_this.props.isUTC ? value.toISOString() : value.toString());
					} else {
						_this.props.changeEvent(null);
					}
				}
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(DatePicker, [{
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps, nextState) {
			return true; // !equal(this.props, nextProps) || !equal(this.state, nextState);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this.props.culture === 'en-CA') {
				this.setState({ months: _Months_1_enCA2.default });
			} else {
				this.setState({ months: _Months_1_frCA2.default });
			}

			var currentYear = new Date().getFullYear();

			if (this.props.mode === 'future') {
				this.setState({ years: this.getOptions(currentYear, this.props.take || 5, this.props.skip || 0) });
			} else if (this.props.mode === 'past') {
				this.setState({ years: this.getOptions(currentYear - (this.props.take || 100) - (this.props.skip || 0), this.props.take || 100, 0).reverse() });
			} else {
				this.setState({ years: this.getOptions(currentYear, 2, this.props.skip || 0) });
			}

			this.setState({ days: this.getOptions(1, 31, 0) });

			var hours = [];

			for (var i = 0; i < 24; i++) {
				var value = i.toString().padStart(2, '0');

				hours.push({ code: value, value: value });
			}

			var minutes = [];

			for (var _i = 0; _i < 60; _i++) {
				var _value = _i.toString().padStart(2, '0');

				minutes.push({ code: _value, value: _value });
			}

			var seconds = [];

			for (var _i2 = 0; _i2 < 60; _i2++) {
				var _value2 = _i2.toString().padStart(2, '0');

				seconds.push({ code: _value2, value: _value2 });
			}

			this.setState({ hours: hours, minutes: minutes, seconds: seconds });

			this.setValue();
		}
	}, {
		key: 'getOptions',
		value: function getOptions(start, take, skip) {
			var options = [];

			for (var i = 0; i < parseInt(take); i++) {
				var value = start + parseInt(skip) + i;
				options.push({ code: '' + value, value: '' + value });
			}

			return options;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_grid2.default,
				null,
				_react2.default.createElement(
					_row2.default,
					{ nogutter: true },
					_react2.default.createElement(
						_column2.default,
						{ xs: 12,
							md: 4,
							nogutter: this.props.mobile,
							nogutterleft: true
						},
						_react2.default.createElement(_dropDown2.default, {
							value: this.state.month && { code: this.state.month },
							references: this.state.months,
							changeEvent: function changeEvent(value) {
								return _this2.handleDate(_this2.state.year, value.code, _this2.state.day, _this2.state.hour, _this2.state.minute, _this2.state.second);
							},
							filterMode: false
						})
					),
					_react2.default.createElement(
						_column2.default,
						{ xs: 6,
							md: 4,
							nogutterleft: this.props.mobile
						},
						_react2.default.createElement(_dropDown2.default, {
							value: this.state.day && { code: this.state.day },
							references: this.state.days,
							changeEvent: function changeEvent(value) {
								return _this2.handleDate(_this2.state.year, _this2.state.month, value.code, _this2.state.hour, _this2.state.minute, _this2.state.second);
							},
							filterMode: false
						})
					),
					_react2.default.createElement(
						_column2.default,
						{ xs: 6,
							md: 4,
							nogutterright: true
						},
						_react2.default.createElement(_dropDown2.default, {
							value: this.state.year && { code: this.state.year },
							references: this.state.years,
							changeEvent: function changeEvent(value) {
								return _this2.handleDate(value.code, _this2.state.month, _this2.state.day, _this2.state.hour, _this2.state.minute, _this2.state.second);
							},
							filterMode: false
						})
					)
				),
				this.props.time && _react2.default.createElement(
					_row2.default,
					{ nogutterbottom: true },
					_react2.default.createElement(
						_column2.default,
						{ xs: 4,
							nogutterleft: true
						},
						_react2.default.createElement(_dropDown2.default, {
							value: this.state.hour && { code: this.state.hour },
							references: this.state.hours,
							changeEvent: function changeEvent(value) {
								return _this2.handleDate(_this2.state.year, _this2.state.month, _this2.state.day, value.code, _this2.state.minute, _this2.state.second);
							},
							filterMode: false
						})
					),
					_react2.default.createElement(
						_column2.default,
						{ xs: 4 },
						_react2.default.createElement(_dropDown2.default, {
							value: this.state.minute && { code: this.state.minute },
							references: this.state.minutes,
							changeEvent: function changeEvent(value) {
								return _this2.handleDate(_this2.state.year, _this2.state.month, _this2.state.day, _this2.state.hour, value.code, _this2.state.second);
							},
							filterMode: false
						})
					),
					_react2.default.createElement(
						_column2.default,
						{ xs: 4,
							nogutterright: true
						},
						_react2.default.createElement(_dropDown2.default, {
							value: this.state.second && { code: this.state.second },
							references: this.state.seconds,
							changeEvent: function changeEvent(value) {
								return _this2.handleDate(_this2.state.year, _this2.state.month, _this2.state.day, _this2.state.hour, _this2.state.minute, value.code);
							},
							filterMode: false
						})
					)
				)
			);
		}
	}]);

	return DatePicker;
}(_react2.default.Component);

DatePicker.defaultProps = {
	isUTC: false
};
exports.default = DatePicker;